import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const Brand = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  const handleSearch = () => {
    if (searchTerm.trim()) {
      const formattedSearchTerm = searchTerm.trim().replace(/\s+/g, "-").toLowerCase(); // Replace spaces with hyphens
      navigate(`/search/${formattedSearchTerm}`);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  return (
    <div className="brand">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-3 col-md-4">
            <div className="b-logo">
              <a href="/">
                <img src="/img/logo.png" alt="Logo" />
              </a>
            </div>
          </div>
          <div className="col-lg-6 col-md-4"></div>
          <div className="col-lg-3 col-md-4">
            <div className="b-search">
              <input
                type="text"
                placeholder="Search"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onKeyDown={handleKeyDown} // Trigger search on Enter key
              />
              <button onClick={handleSearch}>
                <i className="fa fa-search"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Brand;